import type { Adaptors } from '@reactvideoeditor/react-video-editor/types';
import type { searchStock } from '@/rve/stockApi';
import type { StockAudioItem } from '@/rve/stockTypes';

type SoundAdaptor = NonNullable<Adaptors['audio']>[number];
type SoundSearchParams = Parameters<SoundAdaptor['search']>[0];

export interface AspectlyFreesoundAdaptorDeps {
  searchStock: typeof searchStock;
}

const FREESOUND_ADAPTOR_META = {
  name: 'freesound',
  displayName: 'Freesound',
  description: 'Permissive-licensed audio via Aspectly',
  requiresAuth: false,
} as const;

/** Org-scoped Freesound search (backend proxy; preview MP3 URLs in results). */
export function createAspectlyFreesoundAudioAdaptor(
  orgId: number,
  deps?: AspectlyFreesoundAdaptorDeps,
): SoundAdaptor {
  return {
    ...FREESOUND_ADAPTOR_META,
    async search(params: SoundSearchParams) {
      const { searchStock: search } =
        deps ?? (await import('@/rve/stockApi'));
      const query = (params.query ?? '').trim();
      if (!query) {
        return { items: [], totalCount: 0, hasMore: false };
      }
      const result = await search(orgId, 'audio', {
        query,
        page: typeof params.page === 'number' ? params.page : 1,
        perPage: params.perPage,
      });
      return {
        items: result.items as StockAudioItem[],
        totalCount: result.totalCount,
        hasMore: result.hasMore,
      };
    },
    getAudioUrl(audio: StockAudioItem) {
      return audio.file;
    },
  };
}
